import { trpc } from '@/shared/api/trpc';

// Drives a `<ServerSearchSelect>` for an "Assigned to" / account picker
// available to NON-admins. `accounts.searchByName` is admin-only
// (`roleRequired(Role.Admin)`), so this fetches the full active org roster
// via the non-admin `accounts.listForFilters` (`{ id, fullName }`) once
// when the picker opens and filters client-side — same type-to-search UX
// without an RBAC change. Used by the task create form and the
// "Add Task Set" dialog.

export type AssigneeSearchResult = {
  id: string;
  fullName: string;
};

export const useAssigneeSearch = (query: string, open: boolean) => {
  const trimmed = query.trim().toLowerCase();

  const listQuery = trpc.accounts.listForFilters.useQuery(undefined, {
    enabled: open,
    select: (rows): AssigneeSearchResult[] =>
      rows
        .filter((r) =>
          trimmed ? r.fullName.toLowerCase().includes(trimmed) : true
        )
        .map((r) => ({ id: r.id, fullName: r.fullName })),
  });

  return { data: listQuery.data, isLoading: listQuery.isLoading };
};
